export const selectLanguage = (state) => state.language.lang;
